import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Box, Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faPlay, faStop, faThList, faTicket, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';


//export default class TablaProductos extends Component
export default function CashlessEconomyPOSDataTable({pos,onRefresh})
{
    //const [pos,setPos] = useState([]);
    //const [isLoading,setIsLoading] = useState(false);

    //id uuid terminal merchant name brand type status 

    const columns = [
        {
            name : 'uuid',
            label : 'ID',
            options : 
            {
                filter:false,
                searchable:true
            }
        },
        {
            name : 'owner.name',
            label : 'Merchant',
            options:{
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        pos[dataIndex].owner.name
                    );
                },
                filter:true,
                searchable:true
            }
        },
        {
            name : 'name',
            label : 'Nombre',
            options:{
                filter:true,
                //filterType:'dropdown',
                display:true,
                searchable:true
            }
        },
        {
            name : 'brand',
            label : 'Brand',
            
            options:{
                filter:false,
                searchable:true
            }
        },
        {
            name : 'type',
            label : 'Tipo',
            
            options:{
                filter:true
            }
        },
        {
            name : 'status',
            label : 'Estatus',
            options : 
            {
                customBodyRender : (value, tableMeta, updateValue) => (
                    value === 'active'
                    ? <Chip label='Activo' color='success'/>
                    : <Chip label='Inactivo' color='error' />
                )            
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                //onClick = { () => handleChangeStatus(pos[dataIndex].id)  }  
                            >
                                <IconButton>
                                {
                                    pos[dataIndex].status === 'active'
                                    ? 
                                    <Tooltip title='Inactivar' placement="top">
                                        <FontAwesomeIcon icon={faStop}/>
                                    </Tooltip>
                                    :
                                    <Tooltip title='Activar' placement="top">
                                        <FontAwesomeIcon icon={faPlay}/>
                                    </Tooltip>
                                }
                                </IconButton>
                            </Link>

                            
                            <Link 
                                to={'/pos/update/'+pos[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(pos[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Editar' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faEdit}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>

                            <Link 
                                to={'/cashless/pos/details/'+pos[dataIndex].uuid} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(pos[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Detalles' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faClipboardList}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>
                        </div>
                    );
                },

                filter:false,
                print:false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
            
                title={"Listado de POS"}
                data={pos}
                columns={columns}
                options={options}
            />
        </>
    )
}